import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import Header from './components/Header/Header';
import Main from './components/Main/Main';
import Side from './components/Side/Side';
import Footer from './components/Footer/Footer';
import './assets/styles/variables.css';
import './App.css';

const App: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <div className="full-main">
          <Main />
          <Side />
        </div>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
